// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

import { castToFloat } from 'helpers/reduxFormFunctions'
import getGreatestEnabledThroughput from './getGreatestEnabledThroughput'
import getGreatestEnabledPower from './getGreatestEnabledPower'

// when disabling a modulation, need to determine if the engineering reference should update
// if the radio's model number should update
// and if the radio's max/coordinated powers should update.

const disableModulation = (radioName, radioConfig, radioModulationId) => (dispatch, getState) => {
  const sourceForm = getState().pathDetails.get('sourceForm')

  const changeField = (fieldName, value) => (
    dispatch(change(sourceForm, `${radioName}${fieldName}`, value))
  )

  // - if max power is now greater than the greatest of the enabled modulation's power, set it to the highest one.
  // - - must keep coordinated power in sync here as well
  const greatestEnabledPower = getGreatestEnabledPower(radioConfig.modulations, radioModulationId)
  if (
    !radioConfig.maxPower ||
    castToFloat(radioConfig.maxPower) > castToFloat(greatestEnabledPower)
  ) {
    changeField('maxPower', greatestEnabledPower)
    changeField('coordinatedPower', greatestEnabledPower)
  }

  // the modulation with the highest throughout after we disable this radioModulationId
  const greatestEnabledThroughMod = getGreatestEnabledThroughput(radioConfig.modulations, radioModulationId)

  // the displayed model number should always reflect greatestEnabledThroughMod
  if (radioConfig.modelNumber !== greatestEnabledThroughMod.modelNumber) {
    changeField('modelNumber', greatestEnabledThroughMod.modelNumber)
  }

  // if the disabled modulation was also the engineering reference,
  // then we have to set the engineering reference to greatestEnabledThroughMod
  if (radioConfig.engineeringReference === radioModulationId) {
    changeField('engineeringReference', greatestEnabledThroughMod.radioModulationId)
  }

  const greatestBandwidthOfAllEnabledModulations = radioConfig.modulations.reduce((a, d) => {
    if (
      d.radioModulationId !== radioModulationId &&
      d.enabled &&
      (
        a === null ||
        a < d.bandwidth
      )
    ) {
      return d.bandwidth
    } else {
      return a
    }
  }, null)

  if (radioConfig.bandwidth !== greatestBandwidthOfAllEnabledModulations) {
    changeField('bandwidth', greatestBandwidthOfAllEnabledModulations)
  }
}

export default disableModulation
